// エリア別 注文住宅ページ：施工事例のメイン画像とサムネイルを連動させる
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.p-area-works__gallery').forEach(function (gallery) {
    const mainEl = gallery.querySelector('.p-area-works__main');
    const thumbsEl = gallery.querySelector('.p-area-works__thumbs');

    if (!mainEl || !thumbsEl) return;

    const main = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
    });

    const thumbs = new Splide(thumbsEl, {
      fixedWidth: 96,
      gap: 8,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: { 599: { fixedWidth: 72, gap: 6 } },
    });

    main.sync(thumbs);
    main.mount();
    thumbs.mount();
  });
});
